export default {
    strings: {
        pluginNameOneDrive: 'OneDrive',
    },
};
